async function handleFetchResponse(response) {
    if (!response.ok) {
        const error = new Error();
        error.status = response.status;
        throw error;
    }
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
        const res = await response.json();
        return res;
    }
    return response;
}
export async function checkAccess() {
    const response = await fetch(`/buyout/GetBuyoutAccess`, {
        method: "GET",
        headers: { accept: "application/json" }
    });
    const res = await handleFetchResponse(response);
    if (!res.success) {
        throw new Error(res.error || "Access denied");
    }
}
// General buyout page endpoints
export async function fetchBuyoutData(includeNonBuyoutAccounts = false) {
    try {
        const response = await fetch(`/buyout/GetData?includeNonBuyoutAccounts=${includeNonBuyoutAccounts}`, {
            method: "GET",
            headers: { accept: "application/json" }
        });
        const res = await handleFetchResponse(response);
        const contracts = res.Data.Result.Contracts.map((c) => ({
            ...c,
            StartDate: c.StartDate
                ? new Date(c.StartDate).toLocaleDateString("no-NO", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit"
                })
                : c.StartDate,
            EndDate: c.EndDate
                ? new Date(c.EndDate).toLocaleDateString("no-NO", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit"
                })
                : c.EndDate,
            AccountNumber: c.AccountNumber?.split("-")[0]
        }));
        return contracts;
    }
    catch (err) {
        throw err;
    }
}
// Specific buyout endpoints
export async function fetchApplication(applicationNumber) {
    try {
        const response = await fetch(`/buyout/GetApplication?applicationNumber=${applicationNumber}`);
        const res = await handleFetchResponse(response);
        const c = res.data;
        const contract = {
            ...c,
            RemainingTerms: c.RemainingTerms + " terminer",
            TotalTerms: c.TotalTerms + " terminer",
            StartDate: c.StartDate
                ? new Date(c.StartDate).toLocaleDateString("no-NO", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit"
                })
                : c.StartDate,
            EndDate: c.EndDate
                ? new Date(c.EndDate).toLocaleDateString("no-NO", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit"
                })
                : c.EndDate,
            AccountNumber: c.AccountNumber?.split("-")[0]
        };
        return contract;
    }
    catch (err) {
        throw err;
    }
}
export async function fetchBuyoutPrices(applicationNumber, numberOfMonths = 6) {
    try {
        const response = await fetch(`/buyout/GetBuyoutPrices?applicationNumber=${applicationNumber}&numberOfMonths=${numberOfMonths}`);
        const res = await handleFetchResponse(response);
        return res;
    }
    catch (err) {
        throw err;
    }
}
export async function fetchPaymentInformation(applicationNumber, buyoutDate, newAgreement) {
    try {
        const response = await fetch(`/buyout/GetPaymentInformation?applicationNumber=${applicationNumber}&buyoutDate=${buyoutDate}&newAgreement=${newAgreement}`);
        const res = await handleFetchResponse(response);
        return res;
    }
    catch (err) {
        throw err;
    }
}
export async function sendBuyoutEmail(body) {
    try {
        const res = await fetch(`/buyout/SendEmail`, {
            method: "POST",
            credentials: "include",
            body
        });
        const data = await handleFetchResponse(res);
        return data;
    }
    catch (err) {
        throw err;
    }
}
export async function exportBuyoutApplications(contracts) {
    try {
        const res = await fetch("/buyout/GetBuyoutApplicationsAsExcel", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                accept: "application/octet-stream"
            },
            body: JSON.stringify(contracts)
        });
        if (!res.ok) {
            const contentType = res.headers.get("content-type") || "";
            if (contentType.includes("application/json")) {
                const payload = await res.json();
                throw new Error(payload?.error || "Export failed");
            }
            throw new Error("Export failed");
        }
        const blob = await res.blob();
        return blob;
    }
    catch (err) {
        throw err;
    }
}
//# sourceMappingURL=CoreBuyout.js.map